import classNames from 'classnames'
import { observer } from 'mobx-react-lite'
import { type MouseEvent, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { dmsState } from '@/app/store'
import { type IInsuranceCompanyPolicyHolders, type ICompany } from '@/app/types/dmsTypes'
import { routes } from '@Config/config'

import Vector from '../../../Vector.svg'

import style from './Item.module.scss'
import { PolicyHolders } from './PolicyHolders/PolicyHolders'

interface IProps extends ICompany {}

export const Item = observer((props: IProps) => {
    const { id, inn, name, policyHoldersCount, completionSoon } = props
    const navi = useNavigate()

    const [policyHolders, setPolicyHolders] = useState<IInsuranceCompanyPolicyHolders | null>(null)
    const [filter, setFilter] = useState<string>('')

    const onHandleItemClickHandler = () => {
        dmsState.onSetChosenCompany({ edit: { id, inn, name, policyHoldersCount, completionSoon } })
        navi(`${routes.DMSM}/companies/${id}`)
    }

    const onGetPolicyHoldersHandler = (id: string, page: number, filterValue: string) => {
        dmsState.onGetPolicyHoldersByCompanyId(
            id,
            page,
            filterValue,
            (insuranceCompanyPolicyHolders: IInsuranceCompanyPolicyHolders) => {
                setPolicyHolders(insuranceCompanyPolicyHolders)
            }
        )
    }

    const onClickPolicyHoldersCount = (e: MouseEvent<HTMLDivElement>) => {
        e.stopPropagation()
        if (!policyHolders && policyHoldersCount > 0) {
            onGetPolicyHoldersHandler(id, 1, '')
        } else if (policyHolders) {
            setFilter('')
            setPolicyHolders(null)
        }
    }

    return (
        <>
            <div className={style.container} onClick={onHandleItemClickHandler}>
                <div className={style.line}>
                    <div className={classNames(style.cell, style.inn, style.cellCentered)}>
                        <span>{inn}</span>
                    </div>
                    <div
                        className={classNames(
                            style.cell,
                            style.name,
                            completionSoon ? style.comletitionSoonCellLong : style.cellLong
                        )}
                    >
                        {completionSoon ? (
                            <span>
                                {name}
                                <div style={{ display: 'flex' }} title='Договор между СК и ЛПУ скоро завершится'>
                                    <Vector />
                                </div>
                            </span>
                        ) : (
                            <span>{name}</span>
                        )}
                    </div>
                    <div
                        className={classNames(
                            style.quantityWrapper,
                            policyHoldersCount < 1 && style.quantityWrapperDisblead
                        )}
                        onClick={onClickPolicyHoldersCount}
                    >
                        <span>{policyHolders ? 'Скрыть' : policyHoldersCount}</span>
                    </div>
                </div>
            </div>
            {policyHolders && (
                <PolicyHolders
                    filter={filter}
                    setFilter={setFilter}
                    onGetPolicyHoldersHandler={onGetPolicyHoldersHandler}
                    {...policyHolders}
                />
            )}
        </>
    )
})
